import {Component, Injector} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {ScenarioRecording, TrainingSession} from "@models";
import {SimDeviceMappingService, SimRecordingsService, SimSystemService} from "@services";
import {Router} from "@angular/router";
import {EventEmitterService} from "@event-emitter";

export interface DialogData_JoinTrainingRecordingStoppedDialogInput extends MatDialogDataBaseInput {
	trainingSession: TrainingSession;
	scenarioRecording: ScenarioRecording;
	wasAborted?: boolean;
}

export interface DialogData_JoinTrainingRecordingStoppedDialogOutput extends MatDialogDataBaseOutput {}

@Component({
	selector: "sim-join-training-recording-stopped-dialog",
	templateUrl: "./join-training-recording-stopped-dialog.component.html",
	styleUrls: ["./join-training-recording-stopped-dialog.component.scss"],
	providers: [EventEmitterService],
	standalone: false,
})
export class JoinTrainingRecordingStoppedDialogComponent extends BasicMaterialDialog<
	JoinTrainingRecordingStoppedDialogComponent,
	DialogData_JoinTrainingRecordingStoppedDialogInput,
	DialogData_JoinTrainingRecordingStoppedDialogOutput
> {
	public clientProperties = SimDeviceMappingService.clientProperties;
	public isLastRun: boolean = false;

	constructor(
		_injector: Injector,
		private _eventEmitterService: EventEmitterService,
		private _simRecordingService: SimRecordingsService,
		private _router: Router,
	) {
		super(_injector);

		this.checkForFurtherRuns();
	}

	ngOnInit(): void {
		this._eventEmitterService.onScenarioRecordingChanged.subscribe(async (args) => {
			if (args.scenarioRecordingId == this.data.scenarioRecording.id) {
				let rec = await this._simRecordingService.getRecordingById(args.scenarioRecordingId);
				Object.assign(this.data.scenarioRecording, rec);
			}
		});
	}

	private checkForFurtherRuns() {
		if (this.data.trainingSession) {
			this.data.trainingSession.scenarioRecordingGroups.forEach((scenarioRecordingGroup, index) => {
				if (scenarioRecordingGroup.scenarioRecordingsMap[0]?.scenarioRecordingId) {
					if (scenarioRecordingGroup.scenarioRecordingsMap[0].scenarioRecordingId === this.data.scenarioRecording.id) {
						if (index === this.data.trainingSession.scenarioRecordingGroups.length - 1) {
							//Then this is the last run
							this.isLastRun = true;
						}
					}
				}
			});
		}
	}

	public async startDebriefing() {
		if (this.data.scenarioRecording.isReadyForArchive) {
			//SIMSOFT-7859
			await this._router.navigateByUrl(`/debriefing/recording-selection?recordingId=${this.data.scenarioRecording.id}`);
		}
	}
}
